import React, {useCallback} from 'react';
import {publishTrigger} from 'messaging/messages.js';
import Modules from './Modules.js';
import {setIsPlayingMix} from 'actions/index.js';
import { connect } from "react-redux";
import ipfs from 'decentralized/Ipfs.js';
import Row from './Row.js';
import Modals from 'components/v2/Modals.js';
import Playhead from './Playhead.js';
import {useSequencer} from 'components/v2/useSequencer.js';
import '../../Exhibit.scss';

const Exhibit = (props) => {
    window.explore = true;
    window.landing= true;
    window.exhibit = true;
    let sequencerEngine = props.sequencerEngine;
    if (!sequencerEngine) {
        let t = useSequencer(props);
        sequencerEngine = t[1];
    }

    const onClick = useCallback(() => {
        if (!sequencerEngine.playing) {
            let stepData = sequencerEngine.tracks[0].trackData.getCopy();
            stepData.release = null;
            sequencerEngine.tracks[0].midiEffects.liveInputTrigger(stepData);
            setTimeout(() => {
                props.setIsPlayingMix(true);
                sequencerEngine.play();
            }, 500);
        }
    }, [sequencerEngine]);

    let style = {};
    if (props.wallpaper) {
        if (window.isNFT) {
            style.backgroundImage = 'url(' + window.wallpaper + ')';
        } else {
            style.backgroundImage = 'url(' + ipfs.getHashUrl(props.wallpaper) + ')';
        }
    } 

    return (
        <div
          style={style}
          onClick={onClick}
          className="exhibit no-select">
          {sequencerEngine ? <Playhead sequencerEngine={sequencerEngine}/> : ''}
              <Modals sequencerEngine={sequencerEngine}/>
          <Row sequencerEngine={sequencerEngine} row={0}/>
          <Row sequencerEngine={sequencerEngine} row={1}/>
          <Row sequencerEngine={sequencerEngine} row={2}/>
          <Row sequencerEngine={sequencerEngine} row={3}/>
          <Row sequencerEngine={sequencerEngine} row={4}/>
          <Row sequencerEngine={sequencerEngine} row={5}/>
          <Row sequencerEngine={sequencerEngine} row={6}/>
          <Row sequencerEngine={sequencerEngine} row={7}/>
          <Row sequencerEngine={sequencerEngine} row={8}/>
          <Row sequencerEngine={sequencerEngine} row={9}/>
          <Modules sequencerEngine={sequencerEngine}/>
       </div>
        
    );
};

const mapStateToProps = (state, props) => {
    return {
        wallpaper: state.sequencer.wallpaper,
    };
};

const mapDispatchToProps = (dispatch) => ({
    setIsPlayingMix: (p) => dispatch(setIsPlayingMix(p))
});
 
export default connect(mapStateToProps, mapDispatchToProps)(Exhibit);



